module.exports = __webpack_public_path__ + "static/img/b4.4c36945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b4.png
// module id = v8NB
// module chunks = 1